<template>
  <li class="tree-branch">
    <div class="header" :class="{folder:isFolder}" @click="toggle">
      <span v-if="isFolder" class="icon folder arrow-right small" :class="{open:isOpen}" />
      <span class="name">{{ item.name }}</span>
      <span class="size">{{ formatBytes(item.size) }}</span>
    </div>
    <ul v-if="isFolder && isOpen">
      <branch v-for="(child, i) in item.children" :key="i" :item="child" />
    </ul>
  </li>
</template>

<script>
import { bytesToString } from '../../../../lib/storage'
export default {
  name: 'Branch',
  props: {
    item: { type: Object, default: () => ({}) }
  },

  data: () => ({
    isOpen: false
  }),

  computed: {
    isFolder () {
      return !!this.item.children
    }
  },

  methods: {
    formatBytes (bytes) {
      return bytesToString(bytes)
    },
    toggle () {
      if (this.isFolder) {
        this.isOpen = !this.isOpen
      }
    }
  }
}
</script>

<style lang="scss">
  @import "../../../../scss/vars";
  .tree-branch {
    .header {
      display: flex;
      align-items: center;
      position: relative;
      height: $basic-size / 2;
      font-family: font-family-of($ibm-mono);

      &.folder {
        cursor: pointer;
      }
      .icon.folder {
        flex-shrink: 0;
        position: relative;
        display: inline-block;
        width: $basic-size * 0.5;
        height: calc(#{$basic-size / 2} - 8px);
        background: $px-color-grey;
        margin-right: $basic-padding / 2;

        &:after {
          content: '';
          position: absolute;
          width: 40%;
          height: 18%;
          left: 0;
          bottom: calc(100%);
          background: $px-color-grey;
          border-radius: 2px 2px 0 0;
        }
      }
      .size {
        flex-shrink: 0;
        color: $px-color-grey;
      }
      .name {
        flex-grow: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
</style>
